// extracted by mini-css-extract-plugin
module.exports = {"row":"AffiliateCenter_row__2zJuL","col":"AffiliateCenter_col__33QJZ","card":"AffiliateCenter_card__1-Yt4"};